import {
  Alert,
  Box,
  Button,
  Grid,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { BranchAction } from "../Store/Branch";
import { NachRetrievalReducerAction } from "../Store/NachRetrievalReducer";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import store from "../Store";

const NachRetrievalFilter = () => {
  // Maintaining State
  const [branchArray, setBranchArray] = useState([]);
  const [draweeBankArray, setDraweeBankArray] = useState([]);

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  //importing hook
  const dispatch = useDispatch();

  //Selectors from redux store
  const filteredData = useSelector((state) => state.nachRetrieval.filterData);
  const userName = useSelector((state) => state.branch.userName);
  const [dueDateValue, setDueDateValue] = useState(filteredData.dueDate);
  //Input Validtion
  // const branchValid =
  //   filteredData.branchValue !== undefined &&
  //   filteredData.branchValue !== "" &&
  //   filteredData.branchValue !== null;
  const bankNameValid =
    filteredData.bankName !== undefined &&
    filteredData.bankName !== "" &&
    filteredData.bankName !== null;
  const dueDateValid =
    filteredData.dueDate !== undefined &&
    filteredData.dueDate !== null &&
    filteredData.dueDate !== "";
  //Has Error
  // const branchHasError = filteredData.branchTouch && !branchValid;
  const bankNameHasError = filteredData.bankNameTouch && !bankNameValid;
  const dueDateHasError = filteredData.dueDateTouch && !dueDateValid;
  const [dueDateValidDateError, setdueDateValidDateError] = useState(false);
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
    const getSponsorBank = async () => {
      try {
        const response = await axios.post(
          "/retrievalposting/getDraweeBankData",
          {
            branch: "",
          }
        );
        const banks = response.data.map((bank) => {
          return {
            label: bank,
          };
        });
        setDraweeBankArray(banks);
      } catch (error) {
        setMessage("Failed to load Drawee Banks.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    };
    getSponsorBank();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };
  let minDateAddValue = Number(0);
  let maxDateAddValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Nach Retrival Request Date Back Count"] &&
        new Date(
          paramValues["Nach Retrival Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Retrival Request Date Back Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateAddValue = 0;
    } else {
      minDateAddValue =
        fieldAccessMap.nachRetrievalDate &&
        fieldAccessMap.nachRetrievalBackCount
          ? Number(
              paramValues["Nach Retrival Request Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Nach Retrival Request Date Future Count"] &&
        new Date(
          paramValues["Nach Retrival Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Retrival Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateAddValue = 0;
    } else {
      maxDateAddValue =
        fieldAccessMap.nachRetrievalDate &&
        fieldAccessMap.nachRetrievalFutureCount
          ? Number(
              paramValues["Nach Retrival Request Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }
  //shortcut key
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachRetrieval",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      switch (charCode) {
        case "f": //nach filter modify
          searchButtonRef.current.click();
          break;
        case "d": //nach filter clear
          clearRef.current.click();
          break;
        case "o":
          date.setDate(date.getDate() + 1);
          setDueDate(date);
          break;
        case "i":
          setDueDate(new Date());
          break;
        default:
          break;
      }
    }
  };

  //Methods
  // const branchOnChangeHandler = async (value) => {
  //   setDraweeBankArray([]);
  //   dispatch(NachRetrievalReducerAction.updateShowRetrievalList(false));
  //   dispatch(NachRetrievalReducerAction.updateBankNameTouchHandler(false));
  //   dispatch(NachRetrievalReducerAction.updateDueDateTouchHandler(false));
  //   dispatch(NachRetrievalReducerAction.resetGridRows());
  //   dispatch(BranchAction.updateInitialLoad(false));
  //   if (value) {
  //     dispatch(BranchAction.updateHeaderBranchDetails(value.label));
  //     dispatch(NachRetrievalReducerAction.updateBranchValue(value.label));

  //   } else {
  //     dispatch(NachRetrievalReducerAction.updateBranchValue(""));
  //     setDraweeBankArray([]);
  //   }
  //   dispatch(NachRetrievalReducerAction.updateBankNameValue(""));
  //   dispatch(NachRetrievalReducerAction.updateDueDateValue(null));
  // };

  // const setBranchHasTouched = () => {
  //   dispatch(NachRetrievalReducerAction.updateBranchTouchHandler(true));
  // };
  const draweeChangeHandler = (value) => {
    dispatch(
      NachRetrievalReducerAction.updateBankNameValue(value ? value.label : null)
    );
    dispatch(
      NachRetrievalReducerAction.updateBankNameTouchHandler(
        value ? false : true
      )
    );
  };

  const setDueDate = (value) => {
    dispatch(NachRetrievalReducerAction.updateDueDateValue(value));
    dispatch(
      NachRetrievalReducerAction.updateDueDateTouchHandler(value ? false : true)
    );
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const SearchButtonHandler = async () => {
    dispatch(NachRetrievalReducerAction.updateBranchTouchHandler(true));
    dispatch(NachRetrievalReducerAction.updateBankNameTouchHandler(true));
    dispatch(NachRetrievalReducerAction.updateDueDateTouchHandler(true));
    if (bankNameValid && dueDateValid && !dueDateValidDateError) {
      // get the data from DB & load to grid.
      // get the branch Code based on branch.
      const branchWithCodes = GetBranchDetailsWithCode();
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.label === filteredData.branchValue;
      });
      try {
        const response = await axios.post(
          "/retrievalposting/getNachRetrievalData",
          {
            branch: "",
            branchCode: "",
            draweeBank: filteredData.bankName,
            duedate: dayjs(filteredData.dueDate).format("YYYY-MM-DD"),
            createdBy: userName,
            modifiedBy: userName,
          }
        );
        const rowsData = [...response.data].map((row, index) => {
          row.id = index;
          return row;
        });
        dispatch(NachRetrievalReducerAction.updateGridRows(rowsData));
        dispatch(NachRetrievalReducerAction.updateShowRetrievalList(true));
        setMessage(
          response.data.length > 0
            ? "Loaded NACH Retrieval Data Successfully."
            : "No NACH Retrieval Data available."
        );
        setAlertType("success");
        openAlertHandler();
      } catch (error) {
        setMessage("NACH Retrieval Data Load Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    } else {
      return;
    }
  };
  const ClearButtonHandler = () => {
    dispatch(NachRetrievalReducerAction.resetFilterValues());
    dispatch(NachRetrievalReducerAction.updateBranchTouchHandler(false));
    dispatch(NachRetrievalReducerAction.updateBankNameTouchHandler(false));
    dispatch(NachRetrievalReducerAction.updateDueDateTouchHandler(false));
    dispatch(NachRetrievalReducerAction.updateShowRetrievalList(false));
    dispatch(NachRetrievalReducerAction.resetGridRows());
    setdueDateValidDateError(false);
    // setDraweeBankArray([]);
  };

  useEffect(() => {
    // on load reset the values.
    ClearButtonHandler();
    // const branchValues = GetBranchDetails();
    // setBranchArray(branchValues);
  }, []);
  return (
    <Box>
      <AccordianContainer
        id="accord"
        title="Retrieval"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
            {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                required={true}
                type="text"
                placeholder="Select Branch"
                label="Branch"
                autoCompleteValues={branchArray}
                value={filteredData.branchValue}
                onBlur={setBranchHasTouched}
                onChange={(event, newValue) => {
                  branchOnChangeHandler(newValue);
                }}
              />
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid> */}
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                required={true}
                variant="standard"
                type="text"
                placeholder="Select NACH Sponsor Bank"
                label="NACH Sponsor Bank"
                autoCompleteValues={draweeBankArray}
                value={filteredData.bankName}
                onBlur={() => {
                  if (draweeBankArray.length > 0) {
                    dispatch(
                      NachRetrievalReducerAction.updateBankNameTouchHandler(
                        true
                      )
                    );
                  }
                }}
                onChange={(event, newValue) => {
                  draweeChangeHandler(newValue);
                }}
              />
              {bankNameHasError && (
                <p className="error">Please Select NACH Sponsor Bank</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                value={filteredData.dueDate}
                required={true}
                label="Due Date"
                variant="standard"
                minDate={new Date().setDate(
                  new Date().getDate() - minDateAddValue
                )}
                maxDate={new Date().setDate(
                  new Date().getDate() + maxDateAddValue
                )}
                onBlur={(newValue) => {
                  setDueDate(newValue);
                  new Date(newValue).toDateString() !== "Invalid Date" &&
                  newValue !== null &&
                  new Date(newValue).toLocaleDateString().slice(-4) >=
                    String(new Date().getFullYear()) &&
                  new Date(newValue) >=
                    new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
                  new Date(newValue).toLocaleDateString().slice(-4) <= "2055"
                    ? setdueDateValidDateError(false)
                    : setdueDateValidDateError(true);

                  const newDateValue = `${new Date(newValue).getFullYear()}/${
                    new Date(newValue).getMonth() + 1 > 9
                      ? new Date(newValue).getMonth() + 1
                      : "0" + new Date(newValue).getMonth() + 1
                  }/${
                    new Date(newValue).getDate() > 9
                      ? new Date(newValue).getDate()
                      : "0" + new Date(newValue).getDate()
                  }`;
                  const maxValue = new Date().setDate(
                    new Date().getDate() + maxDateAddValue
                  );
                  const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                    new Date(maxValue).getMonth() + 1 > 9
                      ? new Date(maxValue).getMonth() + 1
                      : "0" + new Date(maxValue).getMonth() + 1
                  }/${
                    new Date(maxValue).getDate() > 9
                      ? new Date(maxValue).getDate()
                      : "0" + new Date(maxValue).getDate()
                  }`;

                  const minValue = new Date().setDate(
                    new Date().getDate() - minDateAddValue
                  );
                  const minDateValue = `${new Date(minValue).getFullYear()}/${
                    new Date(minValue).getMonth() + 1 > 9
                      ? new Date(minValue).getMonth() + 1
                      : "0" + new Date(minValue).getMonth() + 1
                  }/${
                    new Date(minValue).getDate() > 9
                      ? new Date(minValue).getDate()
                      : "0" + new Date(minValue).getDate()
                  }`;
                  const specialAccessMaxFlag = newDateValue <= maxDateValue;
                  const specialAccessMinFlag = newDateValue >= minDateValue;
                  specialAccessMaxFlag && specialAccessMinFlag
                    ? setdueDateValidDateError(false)
                    : setdueDateValidDateError(true);
                }}
                onChange={(newValue) => {
                  setDueDate(newValue);
                  new Date(newValue).toDateString() !== "Invalid Date" &&
                  newValue !== null &&
                  new Date(newValue).toLocaleDateString().slice(-4) >=
                    String(new Date().getFullYear()) &&
                  new Date(newValue) >=
                    new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
                  new Date(newValue).toLocaleDateString().slice(-4) <= "2055"
                    ? setdueDateValidDateError(false)
                    : setdueDateValidDateError(true);

                  const newDateValue = `${new Date(newValue).getFullYear()}/${
                    new Date(newValue).getMonth() + 1 > 9
                      ? new Date(newValue).getMonth() + 1
                      : "0" + new Date(newValue).getMonth() + 1
                  }/${
                    new Date(newValue).getDate() > 9
                      ? new Date(newValue).getDate()
                      : "0" + new Date(newValue).getDate()
                  }`;
                  const maxValue = new Date().setDate(
                    new Date().getDate() + maxDateAddValue
                  );
                  const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                    new Date(maxValue).getMonth() + 1 > 9
                      ? new Date(maxValue).getMonth() + 1
                      : "0" + new Date(maxValue).getMonth() + 1
                  }/${
                    new Date(maxValue).getDate() > 9
                      ? new Date(maxValue).getDate()
                      : "0" + new Date(maxValue).getDate()
                  }`;

                  const minValue = new Date().setDate(
                    new Date().getDate() - minDateAddValue
                  );
                  const minDateValue = `${new Date(minValue).getFullYear()}/${
                    new Date(minValue).getMonth() + 1 > 9
                      ? new Date(minValue).getMonth() + 1
                      : "0" + new Date(minValue).getMonth() + 1
                  }/${
                    new Date(minValue).getDate() > 9
                      ? new Date(minValue).getDate()
                      : "0" + new Date(minValue).getDate()
                  }`;
                  const specialAccessMaxFlag = newDateValue <= maxDateValue;
                  const specialAccessMinFlag = newDateValue >= minDateValue;
                  specialAccessMaxFlag && specialAccessMinFlag
                    ? setdueDateValidDateError(false)
                    : setdueDateValidDateError(true);
                }}
              />
              {(dueDateValidDateError || dueDateHasError) && (
                <p className="error">Please Enter Valid Due Date</p>
              )}
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+F" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem", fontWeight: "bold" }}
                onClick={SearchButtonHandler}
                ref={searchButtonRef}
              >
                Detail
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+D" placement="top">
              <Button
                sx={{
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                  fontWeight: "bold",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={ClearButtonHandler}
                ref={clearRef}
              >
                Clear
              </Button>
            </Tooltip>
          </Box>
          <Snackbar
            open={alert}
            autoHideDuration={3000}
            anchorOrigin={{ vertical, horizontal }}
            onClose={closeAlertHandler}
          >
            <Alert
              onClose={closeAlertHandler}
              severity={alertType}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
        </Box>
      </AccordianContainer>
    </Box>
  );
};

export default NachRetrievalFilter;
